import { styled } from '@lyfta/components-theme'

import Subtitle1 from '../Subtitle1'

const Subtitle2 = styled(Subtitle1)`
  font-weight: 700;
`

export default Subtitle2
